import { hasPermission, type User } from '@magimp/shared';
import type { PermissionsBundle } from '../../../stores/auth.js';
import type { RoleKind } from './types.js';

export function detectRoleKind(user: User | null): RoleKind {
  if (!user) return 'manager';
  const n = user.role.name.toLowerCase();
  if (n === 'admin') return 'admin';
  // WHY: backend `roles.service.ts` keeps 'logist' alongside 'logist_cn' for
  // rolling-deploy / snapshot-restore compatibility (SYSTEM_ROLE_NAMES). A
  // user surfaced under the legacy name must map to the same UI role kind so
  // role-aware page copy (subtitle, draft `me.role`) stays consistent.
  // Removable once every environment is past the rename migration.
  if (n === 'logist_cn' || n === 'logist') return 'logist_cn';
  return 'manager';
}

export type RoleSubtitleKey =
  | 'roleSubtitle.manager'
  | 'roleSubtitle.logist_cn'
  | 'roleSubtitle.admin';

export function roleSubtitleKey(role: RoleKind): RoleSubtitleKey {
  if (role === 'manager') return 'roleSubtitle.manager';
  if (role === 'logist_cn') return 'roleSubtitle.logist_cn';
  return 'roleSubtitle.admin';
}

export function canCreateRequest(permissions: PermissionsBundle): boolean {
  return hasPermission(permissions, 'requests.manage');
}
